// <s-language-prompt>: opens its language dialog once for first-time visitors and remembers the choice.
const STORAGE_KEY = 'mypet:language-chosen';

class SLanguagePrompt extends HTMLElement {
  #ac;

  connectedCallback() {
    const dialog = this.querySelector('dialog');
    if (!dialog) return;

    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };

    // Any submit (a language choice) or close (keep current language) counts as answered.
    this.querySelector('form')?.addEventListener('submit', () => this.#remember(), opts);
    dialog.addEventListener('close', () => this.#remember(), opts);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    }, opts);

    if (this.hasAttribute('suppress-auto-open') || this.#answered()) return;
    if (!dialog.open) dialog.showModal();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #answered() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return true;
    }
  }

  #remember() {
    try {
      window.localStorage.setItem(STORAGE_KEY, '1');
    } catch {
      // Storage can be unavailable in private modes; the prompt then simply stays dismissed for this page.
    }
  }
}

if (!customElements.get('s-language-prompt')) {
  customElements.define('s-language-prompt', SLanguagePrompt);
}
